/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-08-12_china-and-art-of the freight.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-08-12_china-and-art-of the freight.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-08-12_china-and-art-of-the-freight.mdx';

const metadata = {
  slug: "2020-08-12_china-and-art-of-the-freight",
  title: "China and the Art of Freight",
  author: "Christian Battaglia",
  description: "The art of the deal via Alibaba RFQs — how nearly everything on Amazon has a Chinese manufacturing counterpart, and what I learned from being employee #5 at FIXD about the OBD2-to-consumer pipeline.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-08-12T00:00:00.000Z",
  
  readTime: "2 min read",
  tags: ["manufacturing","Alibaba","Amazon","FIXD","startups","e-commerce","China","capitalism"],
};

export const Route = createFileRoute('/blog/posts/2020-08-12_china-and-art-of-the-freight')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-08-12_china-and-art-of-the-freight',
    image: '/og/blog/2020-08-12_china-and-art-of-the-freight.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
